const utils = require('../../../lib/utils')

module.exports = {
    config: {
        preventBuildWithoutData: true
    },

    model: {
        grantRender: true
    },

    methods: {
        getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
            resourceFilters = resourceFilters || {}

            if(actionKey === 'refreshResources') {
                resourceFilters.routeID = ((storage.request || {}).route || {}).routeID
            }

            return resourceFilters
        },

        onBeforeRender: function(){
            if(this.config.preventBuildWithoutData){
                this.model.grantRender = utils.collectionSize(this.resourceData.data) > 0
            }
        },
    },

    handlers: [{
        name: 'onSubmitDone',
        componentClass: 'base_bootstrap5_events_applicantRegistrationForm',
        handle: function(callerComponent, nodeData, insertPerformed){
            if(((callerComponent || {}).config || {}).isPostAuth) {
                this.refresh()
            }
        }
    }]
}